import { camelCase, startCase } from 'lodash';
import { zonoApi } from '../api/zonoApi';
import {
  AddGroupMemberRequest,
  CustomerFunnelGroupsListRequest,
  CustomerFunnelGroupsListResponse,
  CustomerFunnelListRequest,
  CustomerFunnelListResponse,
  MoveGroupMembersRequest,
} from './funnel-model';
import {
  FilterRoute,
  ListFilterKey,
  ListFiltersMap,
  updateFiltersByRoute,
} from '../filter';

export const funnelApi = zonoApi.injectEndpoints({
  endpoints: (build) => ({
    getFunnels: build.query<
      CustomerFunnelListResponse,
      CustomerFunnelListRequest
    >({
      query(arg) {
        const { sellerWorkspaceId } = arg;
        return {
          url: `hub/orgs/api/workspaces/${sellerWorkspaceId}/funnels`,
          method: 'GET',
          params: arg,
        };
      },
    }),
    getFunnelGroups: build.mutation<
      CustomerFunnelGroupsListResponse,
      CustomerFunnelGroupsListRequest
    >({
      query({ sellerWorkspaceId, params }) {
        return {
          url: `hub/orgs/api/workspaces/${sellerWorkspaceId}/funnels/groups`,
          method: 'GET',
          params: {
            ...params,
            isReturnNewSemanticConversations: true,
          },
        };
      },
      async onQueryStarted({ isConversation }, { dispatch, queryFulfilled }) {
        if (!isConversation) return;

        queryFulfilled
          .then((response) => {
            const { available_filters } = response?.data?.data;

            const queryType = (available_filters?.query_types || []).map(
              (item) => ({
                id: item?.queryType,
                label: startCase(camelCase(item?.queryType)),
                selected: false,
              })
            );
            const tagsFilter = (available_filters?.tags || []).map((item) => ({
              id: item?.name,
              label: startCase(camelCase(item?.name)),
              selected: false,
            }));
            const teamMembers = (available_filters?.team_members || []).map(
              (item) => ({
                id: item?.id,
                label: startCase(camelCase(item?.name)),
                selected: false,
              })
            );

            const listFilter: Partial<ListFiltersMap> = {};
            if (queryType?.length > 0) {
              listFilter[ListFilterKey.QueryType] = {
                multiSelect: false,
                values: queryType,
              };
            }
            if (tagsFilter?.length > 0) {
              listFilter[ListFilterKey.ConversationTags] = {
                multiSelect: true,
                values: tagsFilter,
              };
            }
            if (teamMembers?.length > 0) {
              listFilter[ListFilterKey.TeamMember] = {
                multiSelect: true,
                values: teamMembers,
              };
            }

            dispatch(
              updateFiltersByRoute({
                route: FilterRoute.Conversation,
                filter: {
                  listFilter,
                },
              })
            );
          })
          .catch((error) => console.log('funnel groups error', error));
      },
    }),
    addGroupMember: build.mutation<any, AddGroupMemberRequest>({
      query({ groupId, body, sellerWorkspaceId }) {
        return {
          url: `hub/orgs/api/customer-group/${groupId}/members`,
          method: 'POST',
          params: { sellerWorkspaceId },
          body,
        };
      },
    }),
    moveGroupMembers: build.mutation<any, MoveGroupMembersRequest>({
      query({ body, sellerWorkspaceId }) {
        return {
          url: `hub/orgs/api/customer-group/move-customers`,
          method: 'POST',
          params: { sellerWorkspaceId },
          body,
        };
      },
    }),
  }),
});

export const {
  useLazyGetFunnelsQuery,
  useGetFunnelGroupsMutation,
  useAddGroupMemberMutation,
  useMoveGroupMembersMutation,
} = funnelApi;
